import { useTranslation } from 'react-i18next';
import {
  LookBackMeasurement,
  LookBackPeriod,
  convertToMeasurement,
  convertToMinutes,
} from '@salecycle/ui-component-library';
import { useCampaignSettings } from '../../CampaignWorkflowTab/state/CampaignSettings/hooks/useCampaignSettings';
import { useCallback, useMemo } from 'react';

export const OnsiteLookBackPeriod = () => {
  const { t } = useTranslation('campaigns');

  const { lookBackPeriod, setLookBackPeriod } = useCampaignSettings();

  const onLookBackPeriodChanged = useCallback(
    (value: number, measurement: LookBackMeasurement) => {
      setLookBackPeriod(convertToMinutes(value, measurement));
    },
    [setLookBackPeriod],
  );

  const defaultLookBackPeriod = useMemo(() => convertToMeasurement(lookBackPeriod), [lookBackPeriod]);

  return (
    <LookBackPeriod
      key={defaultLookBackPeriod.measurement}
      label={t('onsite.campaignSettingsTab.lookBack.label')}
      tooltipHeading={t('onsite.campaignSettingsTab.lookBack.tooltipTitle')}
      tooltipDescription={t('onsite.campaignSettingsTab.lookBack.tooltipDescription')}
      aria-label={t('onsite.campaignSettingsTab.lookBack.ariaLabel')}
      valueAriaLabel={t('onsite.campaignSettingsTab.lookBack.valueAriaLabel')}
      measurementAriaLabel={t('onsite.campaignSettingsTab.lookBack.measurementAriaLabel')}
      onChange={onLookBackPeriodChanged}
      defaultMeasurement={defaultLookBackPeriod.measurement}
      defaultValue={defaultLookBackPeriod.value}
    />
  );
};
